import { useCallback } from 'react';
import { useAuthLocalStorage, } from './utils/useAuthLocalStorage/useAuthLocalStorage';
import { useAuthMethod, } from './utils/useAuthMethod/useAuthMethod';
import { useAuthSearchParams, } from './utils/useAuthSearchParams/useAuthSearchParams';
/** A hook that tries to resolve auth data from various strategies. */
export const useAuthDataResolver = () => {
    const getAuthDataFromSearchParams = useAuthSearchParams();
    const getAuthDataFromAuthMethod = useAuthMethod();
    const getAuthDataFromLocalStorage = useAuthLocalStorage();
    const trigger = useCallback(() => {
        return getAuthDataFromSearchParams()
            .catch(getAuthDataFromAuthMethod)
            .catch(getAuthDataFromLocalStorage);
    }, [
        getAuthDataFromSearchParams,
        getAuthDataFromAuthMethod,
        getAuthDataFromLocalStorage,
    ]);
    return trigger;
};
